import * as React from 'react';
import { connect } from 'react-redux';

import BaseCampaignPage from './BaseCampaignPage';
import PageNotFound from 'components/page/page-not-found/PageNotFound';
import CampaignOutfits from 'modules/product-list/components/campaign-outfits/CampaignOutfits';
import CampaignProductLists from 'modules/product-list/components/campaign-product-lists/CampaignProductLists';

import { t } from 'utils/language';
import { hasProductListPage } from 'utils/products';

import type { Campaign, Params } from 'types';

type OwnProps = {
  params: Params
};

type StateProps = {
  campaign: Campaign,
  canVisitProductListPage: boolean
};

type Props = OwnProps & StateProps;

const CampaignProductListsPage = ({
  campaign,
  canVisitProductListPage,
  params
}: Props) => {
  if (!canVisitProductListPage) {
    return <PageNotFound />;
  }

  return (
    <BaseCampaignPage
      params={params}
      documentTitle={t('campaign_subnavigation_product_lists')}
      pageType="product-lists"
    >
      {
        campaign && campaign.id &&
          <React.Fragment>
            <CampaignProductLists campaignId={campaign.id} />
            <CampaignOutfits campaignId={campaign.id} />
          </React.Fragment>
      }
    </BaseCampaignPage>
  );
};

const mapStateToProps = ({ campaignBrief, organizations, runtimeConfig }): StateProps => ({
  campaign: campaignBrief.brief,
  canVisitProductListPage: hasProductListPage(
    organizations.currentOrganization,
    runtimeConfig?.config?.campaignProductListAccessIds ?? ''
  )
});

export default connect(mapStateToProps)(CampaignProductListsPage);
